export const SETISRELOAD = "SETISRELOAD"
export const DONOR_ID = "DONOR_ID"
export const DONOR_ID_DETAIL = "DONOR_ID_DETAIL"

export const setIsReload = (isReload) => ({
  type: SETISRELOAD,
  isReload
})

